// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CasesApiCasesGetParams = zod.object({
  "asset_id": zod.union([zod.uuid(),zod.null()]).optional()
})

export type CasesApiCasesGetParams = zod.input<typeof CasesApiCasesGetParams>;
export type CasesApiCasesGetParamsOutput = zod.output<typeof CasesApiCasesGetParams>;
